import { Link } from "react-router-dom";
import { ShieldCheck, Truck, Lock, Store } from "lucide-react";

// Compact trust bar shown near the purchase controls (P1.9).
// Only claims consistent with actual, current policies.
const ITEMS = [
  { icon: Truck, label: "Free insured US shipping" },
  { icon: ShieldCheck, label: "30-day returns" },
  { icon: Lock, label: "Secure checkout" },
  { icon: Store, label: "Ship to a Gold Time showroom for pickup" },
];

export const TrustBar = ({ testid = "trust-bar" }) => (
  <div
    className="grid grid-cols-2 gap-x-4 gap-y-3 text-xs text-neutral-600"
    data-testid={testid}
  >
    {ITEMS.map(({ icon: Icon, label }) => (
      <p key={label} className="flex items-center gap-2">
        <Icon size={15} strokeWidth={1.5} className="text-[#C9A227] shrink-0" />
        {label}
      </p>
    ))}
  </div>
);

// Accurate financing line (P1.7/P1.8): Affirm & Klarna are the ONLINE
// options (enabled in Stripe); Acima & Snap are IN-STORE only. No APR,
// monthly amounts or approval claims — those come from the providers.
export const FinancingNote = ({ testid = "financing-note", compact = false }) => (
  <p className={`text-neutral-600 leading-relaxed ${compact ? "text-xs" : "text-sm"}`} data-testid={testid}>
    <span className="font-semibold text-neutral-800">Flexible payment options.</span>{" "}
    Pay over time online with <span className="font-semibold text-neutral-800">Affirm</span> or{" "}
    <span className="font-semibold text-neutral-800">Klarna</span> on eligible orders — choose either at
    checkout. In-store financing with <span className="font-semibold text-neutral-800">Acima</span> and{" "}
    <span className="font-semibold text-neutral-800">Snap Finance</span> is available at{" "}
    <Link to="/showrooms" className="text-[#C9A227] font-semibold hover:text-[#A8871B]">
      our showrooms
    </Link>
    .{" "}
    <Link to="/financing" className="text-[#C9A227] font-semibold hover:text-[#A8871B]">
      How financing works
    </Link>
  </p>
);
